<template>
  <div class="about-xc-page">
    <AboutHero />
    <AboutIntro />
    <PresidentMessage />
    <HonorSection />
    <MilestoneSection />
    <CultureSection />
    <TeamSection />
    <SiteFooter />
  </div>
</template>

<script>
import AboutHero from '@/components/layout/aboutXc/sections/AboutHero.vue'
import AboutIntro from '@/components/layout/aboutXc/sections/AboutIntro.vue'
import PresidentMessage from '@/components/layout/aboutXc/sections/PresidentMessage.vue'
import HonorSection from '@/components/layout/aboutXc/sections/HonorSection.vue'
import MilestoneSection from '@/components/layout/aboutXc/sections/MilestoneSection.vue'
import CultureSection from '@/components/layout/aboutXc/sections/CultureSection.vue'
import TeamSection from '@/components/layout/aboutXc/sections/TeamSection.vue'
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'

export default {
  name: 'AboutXc',
  components: {
    AboutHero,
    AboutIntro,
    PresidentMessage,
    HonorSection,
    MilestoneSection,
    CultureSection,
    TeamSection,
    SiteFooter
  }
}
</script>

<style scoped lang="scss">
.about-xc-page {
  background: #f4f4f4;
  min-width: 1200px;
}
</style>

